import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://unnuevovuelo.com/cart/52915718357216:1';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
      if (e.defaultPrevented) return;
    }
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-3 bg-[#C77D5A] text-[#FAF6F0] px-8 py-5 rounded-full font-semibold text-lg md:text-xl shadow-lg hover:shadow-xl hover:bg-[#b56a48] transition-all duration-300 w-full md:w-auto ${className}`} style={{
    fontFamily: "'Inter', sans-serif"
  }} {...props} data-id="element-133">
      <span data-id="element-134">{children}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-135" />
    </motion.button>;
}